import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import TemplateListItem from './TemplateListItem';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import styled from 'styled-components';

const EmptyTemplatesMsg = styled.p`
  font-size: 14px;
  margin-left: var(--cc_size_spacing_l);
`;

const TemplatesList = ({ templates = [], loading, error }) => {
  if (loading && templates.length === 0) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <EmptyTemplatesMsg>
        <FormattedMessage
          id="Projects.taskList.templates.error"
          defaultMessage="There was an error getting templates."
          description="Text for getting template error"
        />
      </EmptyTemplatesMsg>
    );
  }

  if (!templates.length) {
    return (
      <EmptyTemplatesMsg>
        <FormattedMessage
          id="Projects.taskList.templates.empty"
          defaultMessage="No Templates Found"
          description="Text for when template list is empty"
        />
      </EmptyTemplatesMsg>
    );
  }

  return templates.map((template) => (
    <TemplateListItem key={template.id} template={template} />
  ));
};

TemplatesList.propTypes = {
  templates: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default TemplatesList;
